<div class="ui-g-12 ui-md-3">
  <app-fondo-di-accantonamento-indicator [data]="data" ></app-fondo-di-accantonamento-indicator>
</div>
<div class="ui-g-12 ui-md-3" *ngFor="let point of pointData;">
  <div class="card">
    <p style="color: #6B77A1;text-align: left;padding-left:0.5em;">{{  point.name ? point.name : '-' }}</p>
    <p *ngIf="point.current" style="font-size: 22px;color: #20417b;font-weight: bold;text-align: center"> {{ point.current | number : '1.2-2'}} {{ point.unitOfMeasure }} </p>
    <p *ngIf="point.previous" style="color: #20417b;text-align: center">
      Prec: {{ point.previous | number : '1.2-2' }}
      <span style="color: green;" *ngIf="point.diffPercentage >= 0">  ( + {{ point.diffPercentage | number : '1.2-2'}} % ) </span>
      <span style="color: red;"  *ngIf="point.diffPercentage < 0">( - {{ point.diffPercentage | number : '1.2-2'}} % )</span>
    </p>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/views/loyalty/widgets/point-loyalty-widget/point-loyalty-widget.component.html